module.exports = __webpack_public_path__ + "img/4.479fc26b.jpg";